import {
  LuLayoutDashboard,
  LuUsers,
  LuCreditCard,
  LuGraduationCap,
  LuVideo,
  LuFileText,
  LuFolder,
  LuTrendingUp,
  LuCalendar,
  LuArrowUpDown,
  LuZap,
  LuMegaphone,
  LuBell,
  LuMessageSquare,
  LuPanelTop,
  LuLayoutTemplate,
  LuScale,
  LuLayoutGrid,
  LuSettings,
  LuTag,
  LuMail,
  LuSmartphone,
  LuDatabase,
  LuUserCheck,
  LuShield,
  LuCircle,
  LuLayers,
  LuNewspaper,
  LuCircleHelp,
  LuQuote,
  LuGlobe,
} from 'react-icons/lu';

interface NavIconProps {
  to: string;
  size?: number;
  className?: string;
}

export function NavIcon({ to, size = 16, className = 'nv-icon' }: NavIconProps) {
  const path = to.replace(/^\//, '').replace(/\/$/, '');

  let IconComponent = LuCircle;

  switch (path) {
    // Overview
    case 'dashboard':
      IconComponent = LuLayoutDashboard;
      break;
    case 'members':
      IconComponent = LuUsers;
      break;
    case 'payments':
      IconComponent = LuCreditCard;
      break;

    // Learning
    case 'recorded-learning':
      IconComponent = LuGraduationCap;
      break;
    case 'live-batches':
      IconComponent = LuVideo;
      break;

    // News & Analysis
    case 'library':
    case 'articles':
      IconComponent = LuFileText;
      break;
    case 'categories':
      IconComponent = LuFolder;
      break;
    case 'stocks-of-the-day':
      IconComponent = LuTrendingUp;
      break;
    case 'market-news':
      IconComponent = LuNewspaper;
      break;
    case 'market-movers':
      IconComponent = LuArrowUpDown;
      break;
    case 'market-calendar':
      IconComponent = LuCalendar;
      break;

    // Trade Calls
    case 'trade-calls':
      IconComponent = LuZap;
      break;

    // Broker Referral / Ads
    case 'ads':
    case 'advertisements':
      IconComponent = LuMegaphone;
      break;

    // Audience
    case 'notifications':
      IconComponent = LuBell;
      break;
    case 'enquiries':
      IconComponent = LuMessageSquare;
      break;

    // Website
    case 'chrome':
    case 'website/header':
    case 'website/footer':
      IconComponent = LuPanelTop;
      break;
    case 'pages':
    case 'website/home':
      IconComponent = LuLayoutTemplate;
      break;
    case 'faq':
      IconComponent = LuCircleHelp;
      break;
    case 'testimonials':
      IconComponent = LuQuote;
      break;
    case 'legal':
      IconComponent = LuScale;
      break;

    // Settings
    case 'settings/modules':
      IconComponent = LuLayoutGrid;
      break;
    case 'settings':
      IconComponent = LuSettings;
      break;
    case 'plans':
    case 'news-plans':
    case 'trade-call-plans':
      IconComponent = LuTag;
      break;
    case 'settings/email':
      IconComponent = LuMail;
      break;
    case 'settings/mobile-otp':
      IconComponent = LuSmartphone;
      break;
    case 'settings/news-feeds':
      IconComponent = LuNewspaper;
      break;
    case 'settings/backups':
      IconComponent = LuDatabase;
      break;
    case 'team':
      IconComponent = LuUserCheck;
      break;
    case 'roles':
      IconComponent = LuShield;
      break;

    default:
      IconComponent = LuCircle;
      break;
  }

  return <IconComponent size={size} className={className} aria-hidden="true" />;
}

export function GroupNavIcon({ groupKey, size = 16, className = 'nvgrp-icon' }: { groupKey: string; size?: number; className?: string }) {
  let IconComponent = LuCircle;

  switch (groupKey) {
    case 'overview':
      IconComponent = LuLayers;
      break;
    case 'learning':
      IconComponent = LuGraduationCap;
      break;
    case 'news':
      IconComponent = LuNewspaper;
      break;
    case 'calls':
      IconComponent = LuZap;
      break;
    case 'broker':
      IconComponent = LuMegaphone;
      break;
    case 'audience':
      IconComponent = LuUsers;
      break;
    case 'website':
      IconComponent = LuGlobe;
      break;
    case 'settings':
      IconComponent = LuSettings;
      break;
    default:
      IconComponent = LuLayers;
      break;
  }

  return <IconComponent size={size} className={className} aria-hidden="true" />;
}

